const styles = (theme) => ({
  title: ({ fullPage }) => ({
    [theme.breakpoints.down('sm')]: {
      textAlign: 'center',
    },
    textAlign: fullPage ? 'center' : 'left',
    ...(fullPage ? { color: theme.palette.text.primary } : {}),
  }),
  container: ({ safePaddingEnabled = false }) => ({
    '@supports (padding-top: env(safe-area-inset-top))': {
      paddingTop: safePaddingEnabled ? 'env(safe-area-inset-top)' : 0,
    },
  }),
  minFullHeight: ({ hideHeader = false, headerPosition }) => ({
    [theme.breakpoints.up('md')]: {
      minHeight:
        hideHeader || headerPosition === 'static'
          ? '100vh'
          : 'calc(100vh - 65px)',
    },
    [theme.breakpoints.down('sm')]: {
      minHeight: '100vh',
    },
  }),
  root: {
    [theme.breakpoints.up('md')]: {
      minHeight: '100vh',
    },
  },
  content: ({ lessMarginLeft, noPadding, noPaddingTop }) => ({
    marginLeft: lessMarginLeft ? theme.spacing(4) : 'auto',
    paddingBottom: noPadding ? 0 : theme.spacing(3),
    paddingTop: noPadding || noPaddingTop ? 0 : theme.spacing(3),

    '@supports (padding-bottom: env(safe-area-inset-bottom))': {
      paddingBottom: noPadding
        ? 'env(safe-area-inset-bottom)'
        : `calc(env(safe-area-inset-bottom) + ${theme.spacing(3)}px)`,
    },

    [theme.breakpoints.down('md')]: {
      paddingBottom: noPadding ? 0 : theme.spacing(2),
      paddingTop: noPadding || noPaddingTop ? 0 : theme.spacing(2),

      '@supports (padding-bottom: env(safe-area-inset-bottom))': {
        paddingBottom: noPadding
          ? 'env(safe-area-inset-bottom)'
          : `calc(env(safe-area-inset-bottom) + ${theme.spacing(2)}px)`,
      },
    },
  }),
  // for the tabs
  tabIndicator: {
    height: '4px',
  },
  tab: {
    fontWeight: 600,
    textTransform: 'none',
  },
  marginLeftZero: {
    marginLeft: 0,
  },
});

export default styles;
